import { HttpErrorResponse } from '@angular/common/http';
import { InsightsService } from '@maximizer/core/shared/insights';
import { normalizeError } from '@maximizer/shared/util';

export function trackTimelineException(
  insights: InsightsService | null,
  error: unknown,
  component: string,
  operation: string,
): void {
  const message =
    error instanceof HttpErrorResponse ? error.message : normalizeError(error);
  insights?.trackException(
    { exception: error instanceof Error ? error : new Error(message) },
    {
      component,
      operation,
      httpStatus: error instanceof HttpErrorResponse ? error.status : undefined,
    },
  );
}
